import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import DataSvc from "../../../services/dataSvc";
import InputTextArea from "../../FormElement/InputTextarea";
import { MediaUpload } from "../../FormElement/MediaUpload";
import { ModalPleaseWait } from "../../ModalPleaseWait";

import "./styles.scss";

interface IModalUploadMediaCatalogueProps {
  locationId: string;
  onClose: () => void;
  onSuccess?: () => void;
}

export const ModalUploadMediaCatalogue: React.FunctionComponent<
  IModalUploadMediaCatalogueProps
> = ({ locationId, onClose, onSuccess }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`modalUploadMediaCatalogue.${key}`);

  const [files, setFiles] = useState<File[]>([]);
  const [filesError, setFilesError] = useState<string | undefined>(undefined);
  const [description, setDescription] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const canSubmit = files.length > 0 && !filesError;

  const handleSubmit = async () => {
    if (!canSubmit) return;

    const formData = new FormData();
    formData.append("media", files[0]);
    formData.append("description", description);

    setIsLoading(true);
    try {
      await DataSvc.uploadMediaCatalogueItem(locationId, formData);
      toast.success(t("upload_success"));
      onClose();
      if (onSuccess) onSuccess();
    } catch {
      // Axios handles displaying the error automatically.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal modal-default modal-upload-media-catalogue">
      <div className="modal-mains">
        <button className="btn-close" onClick={onClose}></button>
        <div className="modal-mains__body">
          <h2>{t("title")}</h2>
          <div className="upload-section">
            <MediaUpload
              maxFiles={1}
              maxSizeMiB={5}
              minWidth={400}
              minHeight={300}
              files={files}
              changeFiles={setFiles}
              error={filesError}
              changeError={setFilesError}
            />
          </div>
          <div className="description-section">
            <label className="field-label">{t("description_label")}</label>
            <InputTextArea
              value={description}
              onChange={setDescription}
              placeholder={t("description_placeholder")}
            />
          </div>
          <div className="bottom-btns">
            <button className="btn btn-border" onClick={onClose}>
              {t("cancel")}
            </button>
            <button
              className="btn btn-blue"
              onClick={handleSubmit}
              disabled={!canSubmit}
            >
              {t("upload")}
            </button>
          </div>
        </div>
      </div>
      {isLoading && <ModalPleaseWait description={t("please_wait")} />}
    </div>
  );
};

export default ModalUploadMediaCatalogue;
